import { useState, useEffect } from 'react';
import { cn } from '@/lib/utils';

function formatDuration(startTime) {
  const diffMs = new Date() - new Date(startTime);
  const hours = Math.floor(diffMs / 3600000);
  const mins = Math.floor((diffMs % 3600000) / 60000);
  return `${hours}h ${String(mins).padStart(2, '0')}m`;
}

export function LiveDurationCounter({ startTime, className }) {
  const [, setTick] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setTick((t) => t + 1);
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  if (!startTime) return null;

  return (
    <span className={cn('font-mono text-sm font-semibold text-foreground', className)}>
      {formatDuration(startTime)}
    </span>
  );
}
